import apiRequestService from '@/commonProject/service/apiRequestService';

export default class signinResetRepository {
    /**
     * パスワードリセット1APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async sendPasswordReset1Api(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/pwdrst1', requestBody, idToken);
        return result;
    }

    /**
     * パスワードリセット2APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async sendPasswordReset2Api(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/pwdrst2', requestBody, idToken);
        return result;
    }
}
